import { useEffect, useState } from 'react';
import accountApis from '../../../../../services/accountApis';
import { AxiosResponse } from 'axios';
import { IInfoDevice } from '../types';

const useGetInfoDevice = (shopId: string) => {
  const [data, setData] = useState<IInfoDevice[] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res: AxiosResponse<{ data: IInfoDevice[] }> = await accountApis.getInfoDevice(shopId);
      setData(res?.data?.data);
    } catch (error) {
      console.error('Error fetching SMS package dashboard:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (shopId) {
      fetchData();
    }
  }, [shopId]);

  return { data, loading, refetch: fetchData };
};

export default useGetInfoDevice;
